import { createFileRoute } from '@tanstack/react-router';
import { WebhooksTab } from '@/features/integrations';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/integrations/all/webhooks')({
  component: WebhooksTab,
});
